import { Route } from '@angular/router';

import { ActionCreator, on, ReducerTypes } from '@ngrx/store';

import * as GlobalActions from '@fcom/core/actions/global.actions';
import { RootPaths } from '@fcom/core/constants';
import * as GlobalBookingActions from '@fcom/common/store/actions/global-booking.actions';
import * as BookingActions from '@fcom/booking/store/actions/booking.actions';
import * as OffersActions from '@fcom/booking/store/actions/offers.actions';
import { leaveError } from '@fcom/common/store/actions/error.actions';

import * as SeatMapActions from '../actions/seat-map.actions';

/**
 * Returns an NgRx `on()` handler that resets state to `resetValue` for all
 * booking-flow actions that also reset seatMapReducer to its initial state.
 *
 * Route-sensitive: when the action carries `route.path === MANAGE_BOOKING_ROOT`
 * the state is preserved (mirrors the guard in seatMapReducer).
 *
 * Used by both seatMapReducer and seatsDirtyReducer so that their reset surfaces
 * stay in sync without duplication.
 */
export function onSeatMapFlowReset<S>(resetValue: S): ReducerTypes<S, readonly ActionCreator[]> {
  return on(
    SeatMapActions.reset,
    BookingActions.setTravelType,
    BookingActions.selectTravelClass,
    GlobalBookingActions.setFlights,
    GlobalBookingActions.updateFlight,
    GlobalBookingActions.setPaxAmount,
    GlobalBookingActions.increasePaxAmountField,
    GlobalBookingActions.decreasePaxAmountField,
    GlobalActions.confirmation,
    leaveError,
    OffersActions.reset,
    OffersActions.setInboundId,
    OffersActions.setInboundFareFamily,
    OffersActions.setOutboundId,
    OffersActions.setOutboundFareFamily,
    (state, action) => {
      if ((action as { route?: Route }).route?.path === RootPaths.MANAGE_BOOKING_ROOT) {
        return state as S;
      }
      return resetValue;
    }
  ) as unknown as ReducerTypes<S, readonly ActionCreator[]>;
}
